import styled from 'styled-components';
import breakpoints from 'base/constants/breakpoints';
import { colors, Typography } from 'syngenta-digital-cropwise-react-ui-kit';

export const SectionWrapper = styled.div`
  display: flex;
  gap: 56px;
  padding: 32px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #0092e4;
  background: #eaf6ff;

  @media screen and ${breakpoints.maxWidth.sm} {
    padding: 16px;
    margin: 16px 0;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
`;

export const ContentColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SectionTitle = styled(Typography.Title)`
  && {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.3px;
    color: ${colors.neutral100};
    margin-bottom: 4px;
  }

  @media screen and ${breakpoints.maxWidth.sm} {
    && {
      font-size: 16px;
      font-weight: 550;
      line-height: 24px;
      letter-spacing: -0.0075em;
    }
  }
`;

export const DisclaimerText = styled(Typography.Text)`
  && {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.neutral60};
    display: block;
    margin-bottom: 16px;
  }

  @media screen and ${breakpoints.maxWidth.sm} {
    && {
      font-size: 12px;
      line-height: 18px;
    }
  }
`;

/**
 * DOM element so `dangerouslySetInnerHTML` is allowed.
 */
export const NotesContent = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.neutral100};
  white-space: normal;

  @media screen and ${breakpoints.maxWidth.sm} {
    font-size: 14px;
    line-height: 22px;
  }

  p {
    margin: 0 0 8px;
  }

  ul,
  ol {
    margin: 0 0 8px;
    padding-left: 20px;
  }

  li {
    margin: 4px 0;
  }

  a {
    word-break: break-word;
  }
`;
